import React from 'react';
import { useHistory } from 'react-router-dom';
import Wrapper from '@/components/commons/Wrapper';
import { Row, Col } from 'antd';
import Title from 'antd/es/typography/Title';
import { useTranslation } from 'react-i18next';

export default function PageNotFound() {
  const history = useHistory();

  const { t } = useTranslation();

  React.useEffect(() => {
    //
  }, [history]);

  return (
    <>
      <Wrapper header={true}>
        <Row className="full-wrapper" justify="center" align="middle">
          <Col
            span={12}
            className="custom-login-form"
            style={{ textAlign: 'center' }}
          >
            <div className="logo">
              <img
                src={`${process.env.REACT_APP_BACKEND_URL}/images/logoPDF.png`}
                alt=""
              />
            </div>
            <div>
              <Title level={4}>{t('Page is loading!!')}</Title>
            </div>
          </Col>
        </Row>
      </Wrapper>
    </>
  );
}
